/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Enum field used for ordering the all_wines_by_wine_list query. The value of each key can be used
 * directly by the queryset in the .order_by() function.
 */
export enum AllWinesByWineListOrderField {
  COUNTRY_ASC = "COUNTRY_ASC",
  COUNTRY_DESC = "COUNTRY_DESC",
  CREATED_DATE_ASC = "CREATED_DATE_ASC",
  CREATED_DATE_DESC = "CREATED_DATE_DESC",
  MEMBER_LIKELIHOOD_ASC = "MEMBER_LIKELIHOOD_ASC",
  MEMBER_LIKELIHOOD_DESC = "MEMBER_LIKELIHOOD_DESC",
  PRODUCT_PRICE_ASC = "PRODUCT_PRICE_ASC",
  PRODUCT_PRICE_DESC = "PRODUCT_PRICE_DESC",
  WINE_CLASS_ASC = "WINE_CLASS_ASC",
  WINE_CLASS_DESC = "WINE_CLASS_DESC",
  WINE_REGION_ASC = "WINE_REGION_ASC",
  WINE_REGION_DESC = "WINE_REGION_DESC",
  WINE_TYPE_ASC = "WINE_TYPE_ASC",
  WINE_TYPE_DESC = "WINE_TYPE_DESC",
}

/**
 * Enum field used for ordering all_wines query. Value of each key can be used directly by queryset in
 * .order_by() function.
 */
export enum AllWinesOrderField {
  COLOUR = "COLOUR",
  NEWEST = "NEWEST",
  WINE_BODY_ASC = "WINE_BODY_ASC",
  WINE_BODY_DESC = "WINE_BODY_DESC",
  WINE_PRICE_RANGE_ASC = "WINE_PRICE_RANGE_ASC",
  WINE_PRICE_RANGE_DESC = "WINE_PRICE_RANGE_DESC",
  WINE_TYPE_ASC = "WINE_TYPE_ASC",
  WINE_TYPE_DESC = "WINE_TYPE_DESC",
}

export enum BadgeStatusEnum {
  EARNED = "EARNED",
  IN_PROGRESS = "IN_PROGRESS",
  TODO = "TODO",
}

/**
 * Enum field used for ordering the cellar order items query.
 */
export enum CellarProductsOrderField {
  CREATED_DATE_DESC = "CREATED_DATE_DESC",
  MEMBER_RATING_SCORE_DESC = "MEMBER_RATING_SCORE_DESC",
}

/**
 * Enum field used for ordering a collection's products
 */
export enum CollectionProductOrderField {
  CREATED_DATE_ASC = "CREATED_DATE_ASC",
  CREATED_DATE_DESC = "CREATED_DATE_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_DESC = "PRICE_DESC",
}

export enum ContactMethodEnum {
  EMAIL = "EMAIL",
  SMS = "SMS",
}

export enum ContactTypeEnum {
  BADGE = "BADGE",
  DELIVERY = "DELIVERY",
  NEWSLETTER = "NEWSLETTER",
  SOCIAL = "SOCIAL",
  WINE_SELECTION = "WINE_SELECTION",
}

export enum Kind {
  BOOLEAN = "BOOLEAN",
  SCALE = "SCALE",
}

/**
 * Enum field used for ordering the member_badges_by_category query.
 */
export enum MemberBadgeByCategoryOrderField {
  BADGE_CREATED_DATE_ASC = "BADGE_CREATED_DATE_ASC",
  BADGE_LEVEL_ASC = "BADGE_LEVEL_ASC",
  BADGE_LEVEL_DESC = "BADGE_LEVEL_DESC",
  BADGE_NAME_ASC = "BADGE_NAME_ASC",
  BADGE_NAME_DESC = "BADGE_NAME_DESC",
  BADGE_POINTS_ASC = "BADGE_POINTS_ASC",
  BADGE_POINTS_DESC = "BADGE_POINTS_DESC",
}

/**
 * Which kinds of products a member cellar query surfaces.
 */
export enum MemberCellarScope {
  DRINKS = "DRINKS",
  DRINKS_AND_REWARDS = "DRINKS_AND_REWARDS",
  REWARDS = "REWARDS",
}

export enum MemberMemberGenderChoices {
  F = "F",
  M = "M",
}

export enum MemberMemberLevelBenefitInfoBenefitChoices {
  ADVANCED_WINE_PAIRING_COURSE = "ADVANCED_WINE_PAIRING_COURSE",
  ANNIVERSARY_BOTTLE = "ANNIVERSARY_BOTTLE",
  BIRTHDAY_BOTTLE = "BIRTHDAY_BOTTLE",
  FREE_SHIPPING_4_BOTTLES = "FREE_SHIPPING_4_BOTTLES",
  LIMITED_WINE_RELEASE = "LIMITED_WINE_RELEASE",
  MONTHLY_PRICE_DRAW = "MONTHLY_PRICE_DRAW",
  PRERELEASE_BOTTLE = "PRERELEASE_BOTTLE",
  REGULAR_SAMPLES = "REGULAR_SAMPLES",
  SPECIAL_SAMPLES = "SPECIAL_SAMPLES",
  TOPUP_DISCOUNT = "TOPUP_DISCOUNT",
  WINE_101_COURSE = "WINE_101_COURSE",
}

export enum MemberMemberLevelCreditsUpdateSourceChoices {
  ADMIN_CREDITS = "ADMIN_CREDITS",
  ATTRIBUTION_SURVEY = "ATTRIBUTION_SURVEY",
  EARNED_BADGE = "EARNED_BADGE",
  INACTIVITY = "INACTIVITY",
  NONE = "NONE",
  REDEEMED_PRODUCTS_WITH_POINTS = "REDEEMED_PRODUCTS_WITH_POINTS",
  REDEEMED_REWARDS_CODE = "REDEEMED_REWARDS_CODE",
  REFERRAL = "REFERRAL",
  REFUND = "REFUND",
  REWARDS_V2_MIGRATION = "REWARDS_V2_MIGRATION",
  REWARD_RATINGS = "REWARD_RATINGS",
  SIGNUP_POINTS = "SIGNUP_POINTS",
  WINE_RATINGS = "WINE_RATINGS",
}

export enum OrderFreeBoxCampaignHeroBottomThemeChoices {
  DARK_BG = "DARK_BG",
  LIGHT_BG = "LIGHT_BG",
}

export enum OrderFreeBoxCampaignHeroTopTextPositionChoices {
  CENTER = "CENTER",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum OrderFreeBoxCampaignHeroTopThemeChoices {
  DARK_BG = "DARK_BG",
  LIGHT_BG = "LIGHT_BG",
}

export enum PairingRequestStatus {
  FAILED = "FAILED",
  PENDING = "PENDING",
  READY = "READY",
}

/**
 * Ordering options for the reward store items within a reward collection.
 */
export enum RewardStoreItemOrderField {
  NEWEST_FIRST = "NEWEST_FIRST",
  POINTS_ASC = "POINTS_ASC",
  POINTS_DESC = "POINTS_DESC",
}

export enum SpecialPackSpecialPackEditionHeroBottomThemeChoices {
  DARK_BG = "DARK_BG",
  LIGHT_BG = "LIGHT_BG",
}

export enum SpecialPackSpecialPackEditionHeroTopTextPositionChoices {
  CENTER = "CENTER",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum SpecialPackSpecialPackEditionHeroTopThemeChoices {
  DARK_BG = "DARK_BG",
  LIGHT_BG = "LIGHT_BG",
}

export enum SpecialPackSpecialPackOptionPricePointChoices {
  CLASSIC = "CLASSIC",
  FANCY = "FANCY",
}

export enum SpecialPackSpecialPackOptionWineStyleChoices {
  CHILLABLE = "CHILLABLE",
  MIXED = "MIXED",
  REDS = "REDS",
}

export enum SubscriptionAddOnCategoryChoices {
  BEER = "BEER",
}

export enum SubscriptionAddOnStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  SKIP = "SKIP",
}

export enum SubscriptionStatusEnum {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  NEVER_ACTIVATED = "NEVER_ACTIVATED",
  PAUSE = "PAUSE",
  SKIP = "SKIP",
}

export enum SubscriptionSubscriptionAddOnStatusChoices {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  SKIP = "SKIP",
}

/**
 * Enum for digital wallet types.
 */
export enum WalletTypeEnum {
  APPLE_PAY = "APPLE_PAY",
  GOOGLE_PAY = "GOOGLE_PAY",
  LINK = "LINK",
}

export enum WineWineOakyLevelChoices {
  A_1 = "A_1",
  A_2 = "A_2",
  A_3 = "A_3",
}

export interface AddItemToLocalShoppingCartInput {
  visible: boolean;
  item: LocalShoppingCartInput;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface AddItemsToLocalShoppingCartInput {
  items?: LocalShoppingCartInput[] | null;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface AddOnConfigurationInput {
  addOnId: number;
  status: SubscriptionAddOnStatus;
}

export interface AddShoppingCartItemInput {
  memberId?: number | null;
  productId: number;
  quantity: number;
  extraInfo?: ExtraInfoInput | null;
  redeemWithPoints?: boolean | null;
}

export interface AddressInput {
  id?: number | null;
  firstName: string;
  lastName: string;
  contactNumberCountryCode?: string | null;
  contactNumber: string;
  company?: string | null;
  line1: string;
  line2?: string | null;
  postcode: string;
  city: string;
  state: string;
  extra?: string | null;
  countryId: number;
  addressUnavailableInstructionId: number;
}

export interface ApplyDiscountFromFreeBoxCampaignInput {
  freeBoxCampaignId: number;
  memberId: number;
}

export interface ApplyReactivationCreditInput {
  memberId: number;
  memberWelcomePromoCode: string;
}

export interface ApplyReferralCodeInput {
  memberId: number;
  referralCode: string;
}

export interface BulkAddShoppingCartItemInput {
  productId: number;
  quantity: number;
  extraInfo?: ExtraInfoInput | null;
  redeemWithPoints?: boolean | null;
}

export interface BulkAddShoppingCartItemsInput {
  memberId: number;
  items?: (BulkAddShoppingCartItemInput | null)[] | null;
  subscriptionIntent?: boolean | null;
  includeExistingSubscription?: boolean | null;
  requestId?: string | null;
  firstBoxWineQuantities?: (FirstBoxWineQuantityInput | null)[] | null;
}

export interface CancelPendingBillingOrderInput {
  orderId: number;
  memberId: number;
}

export interface CartItemInLocalShoppingCartInput {
  quantity: number;
  product: ProductInLocalShoppingCartInput;
  extraInfo?: ExtraInfoInLocalShoppingCartInput | null;
}

export interface ChargeAndDispatchOrderNowInput {
  orderId: number;
  expectedTotal?: number | null;
}

export interface CheckoutInput {
  memberId: number;
  shippingAddress?: CheckoutShippingAddressInput | null;
  giftShippingAddress?: AddressInput | null;
  token?: string | null;
  isDefault?: boolean | null;
}

export interface CheckoutShippingAddressInput {
  id?: number | null;
  firstName: string;
  lastName: string;
  contactNumberCountryCode?: string | null;
  contactNumber: string;
  company?: string | null;
  line1: string;
  line2?: string | null;
  postcode: string;
  city: string;
  state: string;
  extra?: string | null;
  countryId: number;
  addressUnavailableInstructionId: number;
  shippingAddressId?: number | null;
}

export interface CreateContactPreferenceInput {
  memberId: number;
  contactMethodId: ContactMethodEnum;
  contactTypeId: ContactTypeEnum;
}

export interface CreateCorporateOrderInput {
  contactEmail: string;
  recipientsSpreadsheetLocation: string;
  extraInformation?: any | null;
}

export interface CreateMemberPaymentMethodInput {
  token: string;
  memberId: number;
}

export interface CreateOneClickTopupPaymentIntentInput {
  wineId: number;
  quantity: number;
}

export interface CreateOrdersPendingAuthorizationInput {
  shippingAddress?: CheckoutShippingAddressInput | null;
  giftShippingAddress?: AddressInput | null;
  expectedTotal?: number | null;
}

export interface CreatePaymentIntentForChargeAndDispatchOrderNowInput {
  orderId: number;
  expectedTotal?: number | null;
}

export interface CreatePaymentIntentForChargeFailedOrderInput {
  orderId: number;
  expectedTotal?: number | null;
}

export interface CreatePaymentSetupIntentInput {
  usage: string;
}

export interface DecreaseQuantityItemInLocalShoppingCartInput {
  productId: number;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface DelayNextBoxInput {
  memberId: number;
  days: number;
  updateBillingDay?: boolean | null;
}

export interface DeleteContactPreferenceInput {
  id: number;
  memberId: number;
}

export interface DeleteItemInLocalShoppingCartInput {
  productId: number;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface DeleteItemsByProductTypeInLocalShoppingCartInput {
  productTypeId: number;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface DeleteMemberPaymentMethodByIdInput {
  paymentMethodId: number;
}

export interface DeleteProductTypeShoppingCartItemsInput {
  memberId: number;
  productTypeId: number;
}

export interface DeleteShoppingCartItemInput {
  productId?: number | null;
  memberId?: number | null;
  shoppingCartItemId?: number | null;
}

export interface DeleteWineListInput {
  id: number;
  memberId: number;
}

export interface ExchangeAutoLoginTokenInput {
  redirectToken: string;
}

export interface ExternalActionInput {
  memberId?: number | null;
  badgeId: number;
  description: string;
}

export interface ExtraInfoInLocalShoppingCartInput {
  giftDeliveryId?: number | null;
  redBottles?: number | null;
  whiteBottles?: number | null;
  sparklingBottles?: number | null;
  roseBottles?: number | null;
  monthsPurchased?: number | null;
  bottlesPerBox?: number | null;
  spendPerBox?: number | null;
  isGift?: boolean | null;
}

/**
 * Class that combines inputs with extra information required by different Product Types.
 */
export interface ExtraInfoInput {
  toMemberEmail?: string | null;
  toMemberFirstName?: string | null;
  toMemberLastName?: string | null;
  toMemberMobileCountryCode?: string | null;
  toMemberMobileNumber?: string | null;
  toMemberPersonalNote?: string | null;
  toMemberShippingAddressId?: number | null;
  holdUntilDate?: string | null;
  giftDeliveryId?: number | null;
  giftTemplateId?: number | null;
  redBottles?: number | null;
  whiteBottles?: number | null;
  sparklingBottles?: number | null;
  roseBottles?: number | null;
  monthsPurchased?: number | null;
  bottlesPerBox?: number | null;
  spendPerBox?: number | null;
  personalNote?: string | null;
  shippingAddressId?: number | null;
  isGift?: boolean | null;
  pairingRequestId?: string | null;
}

export interface FirstBoxWineQuantityInput {
  wineClassId: number;
  numberOfBottles: number;
}

export interface GenerateOneOffRecommendationsInput {
  memberId: number;
  winePriceRangeId?: number | null;
  wineClassId?: number | null;
  excludeWineIds?: (number | null)[] | null;
}

export interface GenericSubscriptionWineInput {
  wineId: number;
  memberId: number;
  quantity?: number | null;
  selectionContext?: SelectionContextInput | null;
  pairingRequestId?: string | null;
}

export interface GetRecommendationsNowInput {
  memberId: number;
}

export interface IncreaseQuantityItemInLocalShoppingCartInput {
  productId: number;
  minBottlesForFreeShipping: number;
  standardShippingFee: number;
}

export interface InviteFriendInput {
  memberId: number;
  email: string;
}

export interface LocalShoppingCartInput {
  items?: (CartItemInLocalShoppingCartInput | null)[] | null;
  visible: boolean;
  totalProductsCost: number;
  totalShippingFee: number;
}

export interface LoginWithOTPInput {
  email: string;
  otpCode: string;
  clientId?: string | null;
}

export interface MarkNotificationsAsReadInput {
  memberId: number;
  activityIds: (number | null)[];
}

export interface MemberMutationInput {
  id?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  password?: string | null;
  birthDate?: any | null;
  gender?: string | null;
  mobileNumber?: string | null;
  hasUpdatedPassword?: boolean | null;
  referralCode?: string | null;
  giveawayCode?: string | null;
  freeBoxCampaignId?: number | null;
  signUpSource?: string | null;
  clientId?: string | null;
  minBottlesForFreeShipping?: number | null;
  minBottlesInOrder?: number | null;
  clientMutationId?: string | null;
}

export interface OnboardingStatusInput {
  id: number;
}

export interface OneClickTopupInput {
  memberId: number;
  wineId: number;
  quantity: number;
}

export interface PreferencesTastebudProfileInput {
  wineClassGroupId: number;
  bodyLevel?: number | null;
  acidityLevel?: number | null;
  sweetnessLevel?: number | null;
  tanninLevel?: number | null;
  fruitDrivenLevel?: number | null;
  oakyLevel?: number | null;
}

export interface PrepareGuestCartTransferInput {
  memberId: number;
}

export interface ProductInLocalShoppingCartInput {
  id: number;
  name: string;
  slug: string;
  sellingPrice: number;
  coverPhotoSmall?: string | null;
  productType?: ProductTypeInLocalShoppingCartInput | null;
}

export interface ProductRatingDetailInput {
  attributeKey: string;
  scaleValue?: number | null;
  booleanValue?: boolean | null;
}

export interface ProductRatingDetailsInput {
  productId: number;
  details: ProductRatingDetailInput[];
}

export interface ProductRatingInput {
  productId: number;
  score: number;
  note?: string | null;
}

export interface ProductTypeInLocalShoppingCartInput {
  id: number;
  canCountTowardsOrderMinimum?: boolean | null;
}

export interface PromoCodeInfoInput {
  name: string;
  memberId: number;
  includeReferral?: boolean | null;
  preferredWineClassId?: number | null;
}

export interface ReactivateAndAddToNextBoxInput {
  wineIds?: (number | null)[] | null;
  productIds?: (number | null)[] | null;
  pointsBasedProductIds?: (number | null)[] | null;
}

export interface RecommendMissingChooseFreeBottleCreditWinesMutationInput {
  excludeWineIds?: (number | null)[] | null;
}

export interface RecommendMissingWinesInput {
  memberId: number;
}

export interface RecommendWineForCreditInput {
  creditId: number;
  excludeWineIds?: (number | null)[] | null;
  wineClassId?: number | null;
}

export interface RecordMemberPhysicalStoreVisitInput {
  locationId: number;
}

export interface RedeemGiftInput {
  redeemCode: string;
  memberId: number;
}

export interface RedeemRewardsCodeInput {
  code: string;
}

export interface RefreshPhysicalStoreRecommendationInput {
  memberId: number;
  locationId: number;
  winePriceRangeId?: number | null;
  wineClassId?: number | null;
  excludeWineIds?: (number | null)[] | null;
}

export interface RefreshRecommendationInput {
  memberId: number;
  replaceWineId?: number | null;
  replaceSubscriptionWineId?: number | null;
  winePriceRangeId: number;
  wineClassId: number;
  excludeWineIds?: (number | null)[] | null;
  locationId?: number | null;
}

export interface RegisterFreeBoxCampaignInterestInput {
  freeBoxCampaignId: number;
  memberId: number;
}

export interface RegisterMemberPaymentMethodInput {
  apiUuid: string;
  supportsOffSessionUsage: boolean;
  wasCvcValidated: boolean;
}

export interface RegisterSpecialPackInterestInput {
  specialPackEditionId: number;
  memberId: number;
}

export interface RemoveShoppingCartDiscountInput {
  memberId: number;
}

export interface RequestMobileNumberVerificationCodeInput {
  memberId: number;
  mobileCountryCode?: string | null;
  mobileNumber: string;
}

export interface RequestOTPLoginInput {
  email: string;
  otpMethod?: string | null;
}

export interface ResetMemberWineQuantitiesInput {
  memberId: number;
  allWineQuantities?: (ResetMemberWineQuantityInput | null)[] | null;
  maximumBoxSpend?: number | null;
  shouldAddSakeOfTheMonth?: boolean | null;
  addOns?: (AddOnConfigurationInput | null)[] | null;
}

export interface ResetMemberWineQuantityInput {
  wineClassId: number;
  winePriceRangeId?: number | null;
  numberOfBottles: number;
}

export interface ResetShoppingCartInput {
  memberId: number;
}

export interface RetryPaymentForChargeFailedOrderInput {
  orderId: number;
  memberId: number;
}

/**
 * Optional member browse context captured at selection time for wine selection
 * event tracking (DEV-4410): the filters the member had applied and any search
 * query. Both optional — the frontend passes whatever state it has.
 */
export interface SelectionContextInput {
  filters?: any | null;
  searchQuery?: string | null;
}

export interface SendGiveawayInviteInput {
  memberId: number;
  code: string;
  email: string;
}

export interface SetBirthdayAnniversaryWineClassInput {
  wineClassId: number;
}

export interface ShippingAddressInput {
  id?: number | null;
  firstName: string;
  lastName: string;
  contactNumberCountryCode?: string | null;
  contactNumber: string;
  company?: string | null;
  line1: string;
  line2?: string | null;
  postcode: string;
  city: string;
  state: string;
  extra?: string | null;
  countryId: number;
  addressUnavailableInstructionId: number;
  memberId: number;
}

export interface SignUpToStandaloneAddOnInput {
  addOnId: number;
  email?: string | null;
  clientId: string;
}

export interface SpecificSubscriptionWineInput {
  subscriptionWineId: number;
  memberId: number;
}

export interface SubmitAttributionSurveyInput {
  attributionType: string;
  otherResponse?: string | null;
}

export interface SubmitBeerQuizInput {
  answerIds: (string | null)[];
  firstName?: string | null;
}

export interface SubmitPairingFeedbackInput {
  pairingRequestId: any;
  rating?: boolean | null;
  feedbackTags?: string[] | null;
  feedbackText?: string | null;
}

export interface SubmitQuizInput {
  answersIds: (number | null)[];
  firstName?: string | null;
  email?: string | null;
  redBottles?: number | null;
  whiteBottles?: number | null;
  roseBottles?: number | null;
  sparklingBottles?: number | null;
  shouldWinesBeAddedToSubscription?: boolean | null;
  welcomePackId?: number | null;
  locationId?: number | null;
  clientId: string;
  clientSecret?: string | null;
  referralCode?: string | null;
  giveawayCode?: string | null;
  preferredWineClassId?: number | null;
}

export interface SubmitRecommendationExplanationFeedbackInput {
  explanationId: number;
  rating?: boolean | null;
  feedbackTags?: string[] | null;
  feedbackText?: string | null;
}

export interface SubmitTasteChallengeAnswerInput {
  memberId: number;
  wineSlug: string;
  tasteChallengeAnswerId: number;
}

export interface SubscriptionInput {
  id: number;
  memberId: number;
  billingDay?: number | null;
  subscriptionStatus?: SubscriptionStatusEnum | null;
  pauseMonths?: number | null;
  holdUntilMonth?: any | null;
  monthFrequency?: number | null;
  subscriptionStatusReasonId?: number | null;
  subscriptionFeedback?: string | null;
}

export interface ToggleShoppingCartSubscriptionInput {
  memberId: number;
}

export interface UpdateBoxAndSpendAddOnConfigurationInput {
  addOnId: number;
  status: SubscriptionAddOnStatus;
}

export interface UpdateBoxAndSpendInput {
  allWineQuantities?: (UpdateBoxAndSpendWineQuantityInput | null)[] | null;
  maximumBoxSpend?: number | null;
  addOns?: (UpdateBoxAndSpendAddOnConfigurationInput | null)[] | null;
}

export interface UpdateBoxAndSpendWineQuantityInput {
  wineClassId: number;
  winePriceRangeId?: number | null;
  numberOfBottles: number;
}

export interface UpdateChallengeProgressInput {
  challengeProgressId?: number | null;
  desiredChallengeStatusId: number;
  badgeId: number;
}

export interface UpdateMemberCreditInput {
  creditId: number;
  preferredWineId?: number | null;
  preferredWineClassId?: number | null;
}

export interface UpdateMemberPaymentMethodByIdInput {
  paymentMethodId: number;
  isDefault: boolean;
}

export interface UpdatePreferencesTastebudProfilesInput {
  preferencesTastebudProfiles: PreferencesTastebudProfileInput[];
}

export interface UpdateReferralCodeInput {
  referralCode?: string | null;
}

export interface UpdateShoppingCartItemInput {
  memberId?: number | null;
  productId?: number | null;
  shoppingCartItemId?: number | null;
  quantity: number;
  extraInfo?: ExtraInfoInput | null;
}

export interface UpdateSubscriptionAddOnInput {
  addOnId: number;
  subscriptionAddOnStatus: SubscriptionAddOnStatus;
}

export interface UpdateWineInWineListInput {
  wineListId: number;
  wineId: number;
  memberId: number;
}

export interface ValidateGiveawayCodeInput {
  referralCode: string;
  giveawayCode: string;
}

export interface ValidatePromoCodeInput {
  code: string;
}

export interface ValidateReferralCodeInput {
  referralCode: string;
}

export interface VerifyMobileNumberInput {
  memberId: number;
  mobileCountryCode?: string | null;
  mobileNumber: string;
  verificationCode: string;
}

export interface WineBlacklistRuleInput {
  memberId: number;
  wineBlacklistTypeId: number;
  objectId?: number | null;
}

export interface WineListInput {
  id?: number | null;
  memberId: number;
  name: string;
  isPublic: boolean;
}

export interface WineRatingInput {
  id?: number | null;
  memberId: number;
  wineId: number;
  score?: number | null;
  note?: string | null;
  liked?: boolean | null;
}

export interface WineRequestInput {
  memberId: number;
  wineId: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
